import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCalendar,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  InputText, SelectEmpresas,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  getEmpresas,
  getTipoArquivosImportacaoPorEmpresa,
} from '../../../../../services/localstorage/localstorage.service'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { parseToMysqlFormat } from '../../../../../services/util/date.service'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  CREATE: 'Criando movimentação de expedição',
  UPDATE: 'Atualizando movimentação de expedição',
  GET_CLIENTS: 'Carregando clientes que estão associadas a essa empresa',
  SUCCESS: 'Movimentação de expedição salvo com sucesso',
}

const INITIAL_STATE = {
  id: 0,
  name: '',
  company_id: 0,
  file_type_id: 0,
  data_operacao: null,
  carga_batida: false,
  empresas: [],
  clientes: [],
  selectedEmpresa: '',
  selectedClient: null,
  tiposImportacao: [],
  operacoes: [],
  savedMovimentacao: {},
  selectedOperacao: null,
  errorMessage: null,
  loadingMessage: LOAD_MESSAGE.NONE,
}

function ModalEstoqueExpedicao({
  dispatch,
  onModalClose,
  onModalSave,
  data,
  show,
  selectedTp,
  operacoes,
}) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (show) {
      setState(prevState => {
        prevState.operacoes = operacoes
        prevState.empresas = getEmpresas()
        const selectedEmpresa = prevState.empresas.find(e => e.id === data.company_id)
        prevState.selectedEmpresa = selectedEmpresa ? selectedEmpresa : 0
        if (selectedEmpresa) {
          let modelosImportacao = getTipoArquivosImportacaoPorEmpresa(selectedEmpresa.id)
          prevState.tiposImportacao = modelosImportacao.map(m => ({
            value: m.file_type_id,
            label: m.importation_file_type,
          }))
          getClientesAssocTpAndCompany(selectedTp, selectedEmpresa.id)
        }
        prevState.selectedOperacao = operacoes.find(op => op.id === data.operacao_estoque_id)
        return {
          ...prevState,
          ...data,
          data_operacao: data.data_operacao ? new Date(data.data_operacao) : new Date(),
        }
      })
    } else {
      setState({ ...INITIAL_STATE })
    }
  }, [show, data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_CLIENTS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        getClientesAssocTpAndCompany(selectedTp, state.selectedEmpresa.id)
        break

      case LOAD_MESSAGE.CREATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        saveMovimentacaoExpedicao(
          state.name,
          state.company_id,
          state.file_type_id,
          selectedTp,
          state.selectedOperacao.id,
          state.selectedClient.id,
          state.data_operacao,
          state.carga_batida,
        )
        break

      case LOAD_MESSAGE.UPDATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        updateMovimentacaoExpedicao(
          state.id,
          state.name,
          state.company_id,
          state.file_type_id,
          selectedTp,
          state.selectedOperacao.id,
          state.selectedClient.id,
          state.data_operacao,
          state.carga_batida,
        )
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedMovimentacao)
        setState({ ...INITIAL_STATE })
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const onFormContentChange = (name, value) => {
    if (name === 'selectedEmpresa') {
      let modelosImportacao = getTipoArquivosImportacaoPorEmpresa(value.id)
      const tipos = modelosImportacao.map(m => ({
        value: m.file_type_id,
        label: m.importation_file_type,
      }))
      setState(prevState => ({
        ...prevState,
        selectedEmpresa: value,
        company_id: value.id,
        tiposImportacao: tipos,
        file_type_id: tipos[0].value,
        loadingMessage: LOAD_MESSAGE.GET_CLIENTS,
      }))
    } else if (name === 'selectedCentral') {
      setState(prevState => ({
        ...prevState,
        selectedCentral: value,
        operationcenter_id: value.id,
      }))
    } else if (name === 'selectedTipoImportacao') {
      setState(prevState => ({ ...prevState, file_type_id: value }))
    } else {
      setState(prevState => {
        prevState[name] = value
        return { ...prevState }
      })
    }
  }

  const onBtnSalvarClicked = state => {
    if (
      state.name === '' ||
      state.company_id === '' ||
      state.file_type_id === '' ||
      !state.selectedOperacao ||
      !state.selectedClient ||
      !state.data_operacao
    )
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Todos os campos devem ser preenchidos',
      }))
    else if (state.id)
      setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.UPDATE }))
    else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CREATE }))
  }

  const updateMovimentacaoExpedicao = async (
    id,
    name,
    company_id,
    file_type_id,
    selectedTp,
    selectedOperacaoId,
    selectedClientId,
    data_operacao,
    carga_batida,
  ) => {
    await EstoqueHttp.updateMovimentacaoExpedicao(selectedTp, {
      id,
      name,
      company_id,
      file_type_id,
      tp_id: selectedTp,
      operacao_estoque_id: selectedOperacaoId,
      client_id: selectedClientId,
      data_operacao: parseToMysqlFormat(data_operacao),
      carga_batida: carga_batida,
    })
      .then(expedicao => {
        setState(prevState => ({
          ...prevState,
          savedMovimentacao: { ...expedicao, data_operacao: new Date(data_operacao) },
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        }))
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const saveMovimentacaoExpedicao = async (
    name,
    company_id,
    file_type_id,
    selectedTp,
    selectedOperacaoId,
    selectedClientId,
    data_operacao,
    carga_batida,
  ) => {
    await EstoqueHttp.createMovimentacaoExpedicao(selectedTp, {
      name,
      company_id,
      file_type_id,
      tp_id: selectedTp,
      operacao_estoque_id: selectedOperacaoId,
      client_id: selectedClientId,
      data_operacao: parseToMysqlFormat(data_operacao),
      carga_batida: carga_batida,
    })
      .then(movimentacao => {
        setState(prevState => ({
          ...prevState,
          savedMovimentacao: { ...movimentacao, data_operacao: new Date(data_operacao) },
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        }))
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const getClientesAssocTpAndCompany = (tp_id, company_id) => {
    EstoqueHttp.getClientesAssocToTpAndCompany(tp_id, company_id)
      .then(res => {
        const resModificado = res.map(c => ({
          id: c.id,
          label: c.id + ' - ' + c.name,
          name: c.name,
        }))
        resModificado.sort((a, b) => a.name.localeCompare(b.name))

        setState(prevState => ({
          ...prevState,
          clientes: resModificado,
          selectedClient: prevState.client_id
            ? resModificado.find(c => c.id === prevState.client_id) || null
            : null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: errorHandler(err),
        })),
      )
  }

  return (
    <CustomModal
      header="Movimentação de Expedição"
      isVisible={show}
      onClose={onModalClose}
      width={600}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Nome :*"
            marginTop={10}
            value={state.name}
            onChange={value => onFormContentChange('name', value)}
          />
        </div>
        <div className="p-col-6">
          <SelectEmpresas
            key={show ? 'open' : 'closed'}
            companyId={state ? state.company_id : ''}
            onChange={value => onFormContentChange('selectedEmpresa', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            placeholder="Selecione um Modelo"
            options={state.tiposImportacao}
            label="Modelos de Importação :*"
            value={state.file_type_id}
            onChange={value => onFormContentChange('selectedTipoImportacao', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            placeholder="Selecione uma Operação"
            optionLabel={'name'}
            options={state.operacoes}
            label={'Operação de Estoque: *'}
            onChange={value => onFormContentChange('selectedOperacao', value)}
            value={state.selectedOperacao}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            placeholder="Selecione um Cliente"
            optionLabel="label"
            options={state.clientes}
            value={state.selectedClient}
            label="Cliente :*"
            filter={true}
            onChange={value => onFormContentChange('selectedClient', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomCalendar
            label={'Data da Operação'}
            onChange={value => onFormContentChange('data_operacao', value)}
            value={state.data_operacao}
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 42 }}>
          <CustomCheckbox
            onChange={value => onFormContentChange('carga_batida', value)}
            checked={state.carga_batida}
          >
            Carga Batida
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={() => onBtnSalvarClicked(state)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalEstoqueExpedicao)
